import { PlainObject } from '../common/types';

export const getUrlParams = (_url: string) => {
  let strs;
  let url = _url || window.location.href;
  const params = {} as PlainObject;
  if (url.indexOf('?') !== -1) {
    url = url.substr(url.indexOf('?'));
    const str = url.substr(1);
    strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      const index = strs[i].indexOf('=');
      params[strs[i].slice(0, index)] = unescape(
        strs[i].slice(index + 1, strs[i].length)
      );
    }
  }
  return params;
};

export const delUrlParam = (paramKey: string, _url: string) => {
  const url = _url || window.location.href;
  let urlParam = window.location.search.substr(1);
  if (_url && url.indexOf('?') > -1) {
    urlParam = url.substr(url.indexOf('?') + 1, url.length);
  } else {
    return url;
  }
  const beforeUrl = url.substr(0, url.indexOf('?'));
  let newQueryString = '';
  const arr = [];
  if (urlParam !== '') {
    const urlParamArr = urlParam.split('&');
    for (let i = 0; i < urlParamArr.length; i++) {
      const paramArr = urlParamArr[i].split('=');
      if (paramArr[0] !== paramKey) {
        arr.push(urlParamArr[i]);
      }
    }
  }
  if (arr.length > 0) {
    newQueryString = '?' + arr.join('&');
  }
  return beforeUrl + newQueryString;
};

export const addUrlParams = (_url?: string, _params?: PlainObject) => {
  const url = _url || window.location.href;
  const params = _params || {};
  const arr: string[] = [];
  let newQueryString = '';
  Object.keys(params).forEach((item) => {
    arr.push(`${item}=${params[item]}`);
  });
  if (url.indexOf('?') > -1) {
    newQueryString = '&' + arr.join('&');
  } else {
    newQueryString = '?' + arr.join('&');
  }
  return url + newQueryString;
};

export const updateUrlParams = (_url: string, key: string, value: string) => {
  if (!value) {
    console.error('[React App Method:updateUrlParams] value is empty');
    return _url;
  }
  const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  const separator = _url.indexOf('?') !== -1 ? '&' : '?';
  if (_url.match(re)) {
    return _url.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return _url + separator + key + '=' + value;
  }
};
